export default {
  forgot_password: "Esqueci minha senha",
  click_here: "Clique aqui",
  about_us_text:
    "A devOZ desenvolve softwares focados em facilitar o mapeamento de dados georreferenciados, com a intenção de gerar informações inteligentes, para decisões estratégicas.",
  about_us: "Sobre nós",
  change_map: "Trocar visualização",
  login: "Login",
  user: "Usuário",
  research: "pesquisar",
  forward: "Avançar",
  dashboard: "Dashboard",
  feedback: "Feedback",
  api_key: "Chave gerada",
  experience_feedback: "Conte-nos como está sendo sua experiência :)",
  update_password: "Atualizar Senha",
  info_username: "Recuperação de Senha",
  recover_msg: "Informe seu e-mail abaixo:",
  assistant: "Assistente de cadastro",
  other_country: "Outro país",
  active: "Ativo",
  create_polygon: "Ativar modo de criação de área de atendimento",
  erase_polygon: "Apagar área de atendimento",
  name_area_placeholder: "Nome da área de cobertura desenhada",
  name_area: "Nome da área:",
  temporarily_unavailable: "Temporariamente indisponível",
  integration: "Integração",
  area: "Área",
  error: "Erro",
  clicks: "Cliques",
  save: "Salvar",
  options: "Opções",
  back: "Voltar",
  copy: "Copiar",
  change: "Alterar",
  copied: "Copiado",
  redirect: "Aguarde enquanto fazemos o seu redirecionamento.",
  ip: "IP",
  cities: "Cidades",
  users: "Usuários",
  about: "Sobre",
  features: "Funcionalidades",
  faq: "faq",
  contact: "Contato",
  cluster: "Cluster",
  heatmap: "Heatmap",

  fields: {
    name: {
      label: "Nome",
      placeholder: "Digite seu nome",
    },
    provider_name: {
      label: "Nome do provedor",
      placeholder: "Digite o nome do provedor",
    },
    user_name: {
      label: "Nome Completo",
      placeholder: "Digite o seu nome completo",
    },
    user_email: {
      label: "E-mail do usuário",
      placeholder: "Digite o e-mail do usuário",
    },
    cnpj: {
      label: "CNPJ",
      placeholder: "Digite seu CNPJ",
    },
    username: {
      label: "Usuário",
      placeholder: "Digite seu usuário",
    },
    password: {
      label: "Senha",
      placeholder: "Digite sua senha",
    },
    password_confirm: {
      label: "Confirmação de senha",
      placeholder: "Confirme sua senha",
    },
    new_password: {
      label: "Nova senha",
      placeholder: "Digite sua nova senha",
    },
    new_password_confirm: {
      label: "Confirmação de nova senha",
      placeholder: "Confirme sua nova senha",
    },
    email: {
      label: "E-mail",
      placeholder: "contato@email.com.br",
    },
    phone: {
      label: "Telefone",
      placeholder: "(99) 99999-9999",
    },
    website: {
      label: "Site",
      placeholder: "Digite o site da empresa",
      hint: "Exemplo: https://www.provedor.com/",
    },
    logo: {
      label: "Logo da empresa",
      placeholder: "Upload da logo",
    },
    agent: {
      label: "Cupom",
      placeholder: "Digite seu cupom",
    },
    facebook: {
      label: "Facebook",
      placeholder: "Link do Facebook",
      hint: "Exemplo: https://www.facebook.com/seuprovedor",
    },
    whatsapp: {
      label: "Whatsapp",
      placeholder: "Número do Whatsapp",
      hint: "55 (DDD) Número - Link do Whatsapp será gerado automaticamente.",
    },
    planSite: {
      label: "Página de planos",
      placeholder: "Digite o link da página de planos",
      hint: "Exemplo: https://www.provedor.com/planos",
    },
  },
  validators: {
    email: {
      required: "Email é obrigatório",
      invalid: "Email deve ser válido",
    },
    name: {
      required: "Nome é obrigatório",
    },
    cnpj: {
      required: "CNPJ é obrigatório",
      invalid: "CNPJ deve ser válido",
    },
    password: {
      required: "Senha é obrigatória",
      min_length: "Senha deve ter no mínimo {0} caracteres",
      required_characters: (v) => !!v,
    },
    website: {
      required: "Site é obrigatório",
      http: 'Opa... está esquecendo o "https://" ou "http://" antes do "www"',
    },
    file: {
      img: "Arquivo em formato não suportado.",
    },
    facebook: {
      required: "Facebook é obrigatório",
      http:
        'Opa. Está esquecendo o "https://" ou "http://" antes do "www.facebook.com"',
      isFacebook: 'Parece que este site não é do Facebook, use o campo "Site"',
    },
    phone: {
      required: "Telefone é obrigatório",
      invalid: "Telefone deve ser válido",
      min_length: "Número inválido",
      only_numbers: "Apenas números",
    },
    required: "Campo obrigatório",
  },

  prospect_finish: {
    thank_you: "Muito obrigado!",
    contact_soon:
      "Em breve entraremos em contato pelo email: <br> <strong>{0}</strong>",
    new_request: "Nova consulta",
    register: "quero ser avisado",
    register_alt: "registrar",
    back: "nova consulta",
    question:
      "Não encontrou o que procurava? Deixe seu contato e vamos avisar sobre novidades em sua região! Registre-se abaixo!",
    suggestion: "Sugerir provedor",
  },

  dialog_suggestion: {
    title: "Sugira um provedor local no campo abaixo:",
    name: {
      label: "Provedor",
      placeholder: "Nome do Provedor",
    },
    toast_msg: "Sugestão enviada com sucesso! Obrigado! :)",
    toast_title: "Sucesso",
    error: "Erro de Sugestão",
    help_us: "Ajude-nos a melhorar nossa cobertura clicando aqui",
  },

  dash_overview: {
    results: "Resultados de ",
    clicks: "Cliques",
    cities: "Cidades",
    filter_data: "Filtrar dados da pesquisa",
    sell_chance: "Quer ter mais chances de venda?",
    upgrade_options: "Confira nossas opções de upgrade",
    see_plans: "Ver planos",
    visualization: "Visualizações",
    daily_evo: "Esta é a evolução diária do seu ISP no período selecionado",
    impression_loc: "Impressões por localização",
    info_user_text: "Pessoas que buscaram em nossa plataforma neste período",
    info_visualization_text: "Este é o número de usuários que viram o seu ISP",
    info_clicks_text: "Este é o número de usuários que foram para a sua página",
    info_cities_text: "Usuários buscaram por você nestas cidades",
    visualizations: "Visualizações",
    impressions_week: "Seu ISP foi visto {impressionsWeek} vezes nesta semana",
    impressions_week_2: "Cada visualização é um chance de venda!",
    welcome: "Bem-vindo ao seu Dashboard <br> na QueroInternet :)",
    welcome_2: "Você está logado como ",
    welcome_3:
      "É importante manter seus dados <br> atualizados. Revise-os se necessário ",
    welcome_4: "clicando aqui.",
    pie_chart: "Origem dos Cliques",
    table_city: "Ranking de cidades onde você apareceu",
  },

  feedback_component: {
    success_msg: "Obrigado pelo seu feedback!",
    success_title: "Enviado com sucesso",
    error_msg:
      "Tente novamente mais tarde ou entre em contato com nosso suporte.",
    error_title: "Ops! Não conseguimos enviar :(",
  },

  integrations: {
    ozmapList1: "Importação de áreas de cobertura",
    ozmapList2: "Integração contínua de novas áreas",
    ozmapList3: "Alteração em massa de áreas",
    ozmapText1: "Importa as áreas de cobertura, conforme definido nas opções.",
    ozmapText2: "Importação das novas caixas",
    ozmapText3: "Alteração em massa de áreas",
    ozmap: "OZmap",
    ozmapURL: "URL do OZmap",
    ozmapAPIkey: "Chave de API - OZmap",
    ozmapAPIkeyHint: "A chave é obtida no próprio OZmap",
    ozmapRadius: "Raio de cobertura ao redor da caixa em metros",
    ozmapRadiusHint:
      "A importação gera um campo em volta de cada caixa e o utiliza como área de cobertura",
    wipeAll: "Apagar todas as áreas atuais",
    wipeAllhint:
      "Apagar todas as áreas presentes antes de importar, isso pode evitar problemas com a duplicação de áreas anteriores",
    config_access: "Configuração de acesso",
    integration_options: "Opções de integração",
    integrate: "Integrar",
    integrated: "Integrado",
    import_areas: "Importação",
    apikey_subheader:
      "Essa chave permite a utilização de integrações - gerada somente uma vez.",
    apikey_header: "Gerar chave de integração",
    activate_integration: "Ativar integração",
    options: "Configuração de integração",
    error_key: "Erro de chave de API",
    active: "Integração ativa",
    inactive: "Integração inativa",
    status_integration: "Fase de Integração",
    new_integration: "Nova integração",
    new_integration_msg: "Insira os dados da nova integração",
    new_integration_title: "Integração:",
    saved_msg:
      "Já iniciamos a nova integração &#129302 Pode levar algum tempo até ser totalmente concluída.",
    updated_msg: "Atualizamos esta integração, logo estará concluída.",
    deleted_msg: "Deletada com sucesso",
    saved_title: "Integração:",
    last_integration: "Última Integração:",
    status: "Status Geral",
    api_key: "Chave API",
    url: "Url",
    created_at: "Data",
    delete_integration: "Deletar",
    update_integration: "Alterar",
    table: "Tabela de Integrações",
    integrations: "Integrações",
    confirm_action: "Confirmar Alteração",
    sync_integration:
      "Estamos sincronizando sua integração novamente, isso pode levar algum tempo",
    created_at_header: "Data de Criação",
    sync_now: "Sincronizar agora",
    list: "Sincronizar agora",
    integrations_available: "Integrações disponíveis",
    auto_sync: "ATUALIZAÇÃO AUTOMÁTICA",
    created_at_msg: "Criado em",
    updated_at: "Atualizado em",
    name: "Nome da Integração",
  },

  provider_list: {
    list: "Lista de provedores <br> encontrados",
    listDesktop: "Lista de provedores encontrados",
    name: "NOME",
    phone: "TELEFONE",
    website: "SITE",
    precision: "PRECISÃO",
    error_msg: "Não encontramos na sua região",
    error_title: "Desculpe",
    contact: "CONTATO",
    buyNow_title: "CONTRATE AGORA",
    error_buyNow: "Não é possivel comprar agora",
  },
  provider_recover: {
    success_title: "Senha alterada.",
    success_msg: "Faça seu login com a nova senha",
    error_title: "Erro ao alterar senha",
    error_msg: "Tente novamente mais tarde ou entre em contato com o suporte",
    error_title_pass: "Senhas não conferem",
    error_msg_pass: "As senhas precisam ser iguais",
  },
  provider_login: {
    do_login: "Faça seu login abaixo ou inicie o seu cadastro:",
    register_wanted: "Quero me cadastrar",
    register_question: "Ainda não tem cadastro?",
    toast_error_title: "Falha no login",
    toast_error_msg:
      "Verifique se as credenciais foram digitadas corretamente.",
    toast_recover_title: "E-mail de recuperação de senha enviado",
    toast_recover_msg: "Verifique a caixa de entrada do e-mail informado.",
    toast_error_recover_title: "Erro",
    toast_error_recover_msg: "Falha ao enviar e-mail de recuperação.",
  },
  prospect_form: {
    title: "Para receber o resultado, por favor preencha os dados abaixo.",
    altTitle: "Deixe seu contato e vamos avisar sobre novidades em sua região!",
    toast_send_title: "Enviamos!",
    toast_send_body: "A lista de provedores estará no seu e-mail em breve.",
    toast_send_title_alt: "Enviamos!",
    toast_send_body_alt:
      "Avisaremos mudar a oferta de provedores em sua região",
    toast_no_providers_msg: "Desculpe, não encontramos provedores da sua área.",
    toast_no_providers_title: "Sem Provedores",
    toast_error_msg: "Desculpe, ocorreu um erro no envio de e-mail.",
    toast_error_title: "Tente novamente",
    toast_error_msg_mail: "Por favor, verifique se foi digitado corretamente.",
    toast_error_title_mail: "Ops... Parece que este e-mail não existe :(",
  },
  prospect_result: {
    title: {
      success: "Encontramos provedores na sua área!",
      failure: "Por enquanto não encontramos provedores na sua área",
    },
    subtitle: {
      success: "Para ver a lista, preencha os dados:",
      failure:
        "Para receber um alerta quando esse dado estiver disponível, preencha um contato abaixo:",
    },
    fields: {
      email: {
        label: "Email",
        placeholder: "contato@email.com.br",
      },
      phone: {
        label: "Telefone",
        placeholder: "(99) 99999-9999",
      },
    },
  },
  account_login: {
    create_account: "Criar conta",
    register: "Cadastrar",
    connect: "Conecte-se",
  },
  account_register: {
    welcome: "Vamos criar a sua nova conta na QueroInternet",
    checkout: "Criar conta",
    checkout_explain:
      "Você será redirecionado para a página de planos e seu cadastro será validado após o retorno.",
  },
  prospect_name: {
    name_question: "Qual o seu nome?",
    name_field_placeholder: "Insira aqui",
  },
  prospect_cancel: {
    option_giveup: "Desisti de procurar.",
    option_other: "Outro motivo. Qual?",
    option_many: "Recebendo muitos e-mails.",
    option_contract: "Já contratei um provedor. Qual?",
    cancel_inscription: "Cancelar inscrição",
    toast_success_msg: "Você não receberá mais e-mails do QueroInternet",
    toast_success_title: "Inscrição cancelada com sucesso",
    toast_error_msg: "Tente novamente mais tarde ou contate o suporte",
    toast_error_title: "Falha ao cancelar",
  },
  edit_areas: {
    toast_success_msg: "Sua área foi criada com sucesso.",
    toast_success_title: "Conseguimos",
    toast_edit_success_msg: "Suas áreas foram editadas com sucesso.",
    toast_edit_success_title: "Conseguimos",
    toast_save_msg: "Isso não deve demorar :)",
    toast_save_title: "Salvando sua nova área",
    toast_error_msg: "Tente novamente mais tarde ou contate o suporte",
    toast_error_title: "Falha ao criar",
    toast_edit_save_title: "Salvando suas novas áreas editadas",
    edit_mode: "Ativar modo de edição",
    disable_edit_mode: "Desabilitar modo de edição",
    search_address: "Procurar endereço",
    instructions_title_mobile:
      "Visualize suas área no mapa ou procure na lista acima.",
    instructions_msg_mobile: " ",
    instructions_title:
      "Utilize os botões no canto superior direito para criar e listar suas áreas",
    instructions_msg: " ",
    instructions_create_title:
      "Clique no mapa para iniciar uma área de cobertura",
    instructions_create_msg: "Não esqueça de confirmar depois :)",
    instructions_edit_title:
      "Clique e arraste os vértices dos polígonos para modificar a área",
    instructions_edit_msg: "Não esqueça de confirmar depois :) ",
    area_size: "Tamanho da área inicial",
    small: "Área pequena",
    medium: "Área média",
    big: "Área grande",
    list: "Lista",
    add: "Criar Área",
    remove: "Remover Área",
    edit: "Editar",
    loading_map: "Carregando mapa e áreas de cobertura :)",
  },
  prospect_location: {
    address_field_placeholder: "Procurar por endereço",
    address: "Endereço",
    centralize_gps: "Localização",
    activate_gps: "Ativar Localização",
    card_field: "Ative a sua localização ou clique no botão de endereço",
    toast_title: "Olá!",
    toast_msg:
      'Conduza o ponteiro ao seu destino ou clique no botão "Endereço"',
    toast_srch_title: "Estamos procurando provedores perto de você.",
    toast_srch_msg: "Isso pode levar alguns segundos.",
    toast_error_title: "Erro",
    toast_error_msg: "Desculpe, ocorreu um erro na procura de provedores.",
    toast_msg_error_gps:
      "Altere as configurações do navegador para ativar a localização ou utilize a pesquisa por endereço",
    toast_title_error_gps: "Localização não habilitada",
  },
  provider_config: {
    edit_data: "Editar cadastro",
    area_list: "Lista de Áreas",
  },

  upload_km: {
    welcome:
      "Faça upload do seu arquivo de cobertura. É possível realizar a importação posteriomente.",
  },

  stepper: {
    step1: "Usuário",
    step2: "Provedor",
    step3: "Área de Cobertura",
    alert:
      "Para dispensar esta tela, cadastre pelo menos o logo do seu provedor.",
  },

  provider_edit: {
    welcome:
      "Completar os dados de seu provedor pode aumentar as suas chances de sucesso:",
    area_list: "Lista de Áreas",
    toast_error_pass_msg: "Verifique se as duas senhas são iguais",
    toast_error_pass_title: "Senhas não conferem",
    toast_error_update_msg:
      "Tente novamente mais tarde e verifique as informações.",
    toast_error_update_title: "Erro ao atualizar seu cadastro",
    toast_update_msg: "Verifique suas informações.",
    toast_update_title: "Cadastro atualizado com sucesso",
  },

  user_edit: {
    welcome: "Edite os dados do seu usuário abaixo:",
  },

  provider_register: {
    welcome: "Complete seu cadastro com os seus dados adicionais:",
    chose_after: "Escolher mais tarde",
    chose_plan: "Escolher plano:",
    register: "Cadastro",
    plans: "Planos",
    payment: "Pagamento",
    impressions: "Impressões ilimitadas por 3 meses.",
    toast_error_pass_msg: "Asegúrate de que las dos contraseñas sean iguales",
    toast_error_pass_title: "Las contraseñas no coinciden",
    toast_error_update_msg: "Tente novamente mais tarde.",
    toast_error_update_title: "Erro no cadastro",
    toast_update_msg: "Salvo no sistema.",
    toast_update_title: "Cadastro efetuado com sucesso",
    toast_kmz_update_msg:
      "Agora é possível excluir as áreas que não pretende incluir",
    toast_kmz_update_title: "Arquivo recebido",
    toast_kmz_error_update_msg:
      "Mas recebemos seu arquivo e entraremos em contato.",
    toast_kmz_error_update_title:
      "Ops! Não conseguimos criar as áreas automaticamente.",
    toast_kmz_error_msg: "Não foi possível fazer o upload o seu arquivo",
    toast_kmz_error_title: "Nenhum arquivo selecionado",
    toast_error_plans_msg:
      "Erro no redirecionamento para nosso agente de pagamentos.",
    toast_error_email_msg: "Parece que este e-mail já está cadastrado.",
    toast_error_email_title: "Ops!",
    large_img_msg: "Tamanho da imagem supera 10mb",
    large_img_title: "Erro de upload",
    large_img_hint: "Tamanho máximo 10mb",
  },

  home: {
    find_providers:
      "<b>Encontre Provedores</b> <br> <i>que atendem sua região.</i>",
    search_now: "Buscar Agora",
  },

  user_register: {
    toast_error_update_msg: "Tente novamente mais tarde.",
    toast_error_update_title: "Erro no cadastro",
    toast_update_msg: "Salvo no sistema.",
    toast_update_title: "Cadastro efetuado com sucesso",
    toast_error_email_msg: "Parece que este e-mail já foi cadastrado.",
    toast_error_email_title: "Ops!",
    welcome: "Vamos criar seu usuário, preencha os dados abaixo:",
    toast_login_title: "Fazendo seu login :)",
    toast_login_msg: "Logo poderá cadastrar o seu provedor",
  },

  wizard: {
    fail_kmz_msg: "Vamos analisar o seu arquivo e entraremos em contato",
    fail_kmz_title: "Mas não se preocupe!",
  },

  dash_plans: {
    situation_plan: "Situação do plano",
    checkout_plans: "Acessar Planos",
    no_plan: "Sem plano",
    plan_system_description:
      "Comece a ser visto pelos seus próximos clientes agora mesmo! Veja as nossas opções de planos e escolha o mais adequado para o seu provedor:",
  },

  stripe: {
    get_plan:
      "Aderindo ao plano você ganha acesso a todas a funcionalidades do sistema.",
    error_provider_title: "Você precisa de um provedor registrado.",
    error_provider_msg: "Registre seu provedor na tela principal.",
    error_session_title: "Ops! Erro na criação de sessão de pagamento.",
    error_session_msg: "Por favor, entre em contato pelo nosso suporte.",
  },

  areas_dashboard: {
    options: "Opções",
    saved_areas_msg: "Áreas de cobertura salvas com sucesso :)",
    saved_areas_title: "Salvo com sucesso",
    not_saved_areas_title:
      "Áreas que não foram salvas em razão de intersecção do polígono em mais de um ponto:",
    deleted_areas_msg: "Áreas de cobertura deletadas com sucesso :)",
    deleted_areas_title: "Deletado com sucesso",
    cities_covered: "Cidades Atendidas",
  },

  provider_dashboard: {
    init_date: "Data de início",
    end_date: "Data final",
    alert:
      "É possível adicionar novas áreas pelo campo de importação de .kmz/.kml abaixo",
    km2: "Km²",
    search: "Procurar",
    confirm_action: "Confirmar Ação",
    data: "Dados",
    plans: "Planos",
    areas: "Minhas Áreas",
    config: "Configurações",
    impressions: "Impressões",
    montly_data: "Impressões Mensais",
    plan_info: "Informações do Plano",
    plan_basic: "Plano Básico",
    label_km: "Upload de aquivo kml / kmz",
    location_h: "Cidades",
    chose_period: "Período de impressões",
    impression: "Impressão",
    click: "Clique",
    cep_h: "CEP",
    city_h: "Cidade",
    month_h: "Mês",
    impression_h: "Impressões",
    change_plan: "Alterar Plano",
    field_kmz: "Selecione seu arquivo de cobertura",
    name_h: "Nome",
    created_h: "Data de Criação",
    active_h: "Ativo",
    actions_h: "Ações",
    toast_area_update_msg: "Modificação efetuada.",
    toast_area_update_title: "Área alterada com sucesso.",
    toast_area_error_update_msg: "Tente novamente mais tarde",
    toast_area_error_update_title: "Erro ao atualizar área",
    toast_area_delete_msg: "Modificação efetuada.",
    toast_area_delete_title: "Área deletada com sucesso.",
    toast_area_error_delete_msg: "Tente novamente mais tarde",
    toast_area_error_delete_title: "Erro ao deletar área",
    confirm_msg: "Para confirmar, aperte no botão de checagem",
    confirm_title: "Confirme a sua ação",
    deactivate: "Desativar",
    activate: "Ativar",
    change_status:
      "Troca o status das áreas selecionadas de ativa para inativa ou em sentido inverso",
    activate_msg: "Ativa a cobertura nesta região.",
    delete: "Deletar Área",
    delete_msg: "Deleta a região selecionada",
    delete_areas: "Deletar Áreas",
    delete_areas_msg: "Deleta as regiões selecionadas",
    filter_by_city: "Filtrar por Cidade",
    search_by_name: "Procurar por Nome",
    filter_update_msg: "Filtro aplicado.",
    filter_update_title: "Áreas:",
  },

  contact_form: {
    contact_us: "Quer aparecer no Quero Internet? <br> Entre em contato",
  },

  impressions: "Impressões",
  impressions_map: "Mapa de Impressões",
  impressions_map_sub:
    "Os ponteiros são uma estimativa de onde seu provedor foi visualizado.",
  data: "Dados",
  plans: "Planos",
  areas: "Áreas",
  areas_map: "Mapa de Cobertura",
  config: "Configurações",
  search: "Procurar",
  map_pointer: "Pontos",
  map_cluster: "Cluster",
  search_alt: "Buscar",
  search_providers: "Buscar Provedores",
  impression: "Impressão",
  click: "Clique",
  country: "País",
  support: "Suporte",
  support_msg: "Entre em contato no e-mail:",
  january: "Janeiro",
  february: "Fevereiro",
  march: "Março",
  april: "Abril",
  may: "Maio",
  june: "Junho",
  july: "Julho",
  august: "Agosto",
  september: "Setembro",
  october: "Outubro",
  november: "Novembro",
  december: "Dezembro",
  person: "Pessoa Física",
  company: "Empresa",
  date_h: "Data",
  email_h: "E-mail",
  coord_h: "Lat/Lng",
  type_h: "Tipo",
  phone_h: "Número",
  address_h: "Endereço",
  month_h: "Mês",
  impression_h: "Impressões",
  access: "Acessar",
  buyNow: "Contrate",
  buyNow_plans: "Ver planos",
  motive: "Motivo do cancelamento",
  provider: "Provedor",
  payment_success:
    "Pronto! Você receberá em seu e-mail a confirmação do pagamento e logo poderá utilizar as funcionalidades do QueroInternet!",
  payment_redirect: "Estamos o redirecionando para a página de login.",
  payment_canceled: "Pagamento cancelado.",
  no_info: "Não informado",
  checkout: "Checkout",
  after: "Depois",
  select: "Selecionar",
  logout: "Sair",
  welcome: "Seja bem-vindo(a)!",
  send: "Enviar",
  enter: "Entrar",
  confirm: "Confirmar",
  contact_us: "Entre em contato",
  register: "Quero me cadastrar",
  im_company: "Sou Empresa",
  im_provider: "Sou Provedor de Internet",
  im_person: "Sou Pessoa Física",
  searching: "Estou buscando internet",
  did_you_know:
    "VOCÊ SABIA QUE HÁ MAIS DE 10 MIL <br>  PROVEDORES DE INTERNET NO BRASIL?",
  did_you_know_mobile:
    "VOCÊ SABIA QUE HÁ MAIS <br> DE 10 MIL PROVEDORES DE <br> INTERNET NO BRASIL?",
  help_description:
    "O QueroInternet te ajuda a conhecer <br> e encontrar alternativas de internet <br> na sua região.",
  help_description_mobile:
    "O QueroInternet te ajuda a <br> conhecer e encontrar alternativas <br> de internet na sua região.",
  click_below: "Clique abaixo e <br> faça uma consulta <br> gratuita agora! ",
  click_right:
    "Clique ao lado e faça uma <br> consulta gratuita agora <br> >> ",
  looking_for_internet: "Estou buscando internet",
  access_points: "Pontos de cobertura",
  coverage_area: "Área de cobertura",
  coverage_areas: "Áreas de cobertura",
  coverage: "Cobertura",
  by_month: "por mês",
  currency: "R$",
  legal_info:
    "Nos termos da Lei Federal n. 13.709/18 (Lei Geral de Proteção de Dados) autorizo a Quero Internet Ltda a compartilhar os meus dados de contato com os provedores que atendem a minha região.",
  plan1: "START:",
  plan2: "PRO:",
  plan3: "PREMIUM:",
  plan_features: {
    phone_number: "Número de telefone",
    website: "Link para o site",
    impressions: "Até {number} impressões",
    cities: "Até {number} cidade | Até {number} cidades ",
    whatsapp: "Link para o Whatsapp",
    facebook: "Link para o Facebook",
    dashboard: "Acesso ao dashboard",
    heat_map:
      "Mapa de calor com <br> pedidos no interior <br> e entorno da sua rede",
  },
  currency_value: "R$ {price}",
  month: "mês",
  subscribe_plan: "Assinar Plano",
  subscribe: "Assinar",
  $vuetify: {
    dataIterator: {
      rowsPerPageText: "Itens por página:",
      itemsPerPageText: "Itens por página:",
      pageText: "{0}-{1} de {2}",
      noDataText: "Não há dados no momento.",
      noResultsText: "Não há dados no momento.",
    },

    dataTable: {
      rowsPerPageText: "Itens por página:",
      itemsPerPageText: "Itens por página:",
      pageText: "{0}-{1} de {2}",
      sortBy: "Ordenar por",
      noDataText: "Não há dados no momento.",
    },
    dataFooter: {
      rowsPerPageText: "Itens por página:",
      itemsPerPageText: "Itens por página:",
      itemsPerPageAll: "Todos",
      pageText: "{0}-{1} de {2}",
      noDataText: "Não há dados no momento.",
    },
    noDataText: "Sem dados no momento",
  },
  whatsappText:
    "Olá, encontrei vocês no QueroInternet e gostaria de mais informações sobre os planos disponíveis para o endereço: {address}",
};
